var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarktheme({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 110,
    viewBox: "0 0 185 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062",
    transform: "translate(-235 -129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8206",
    "data-name": "Rectangle 8206",
    width: 185,
    height: 110,
    rx: 5,
    transform: "translate(235 129)",
    fill: "#2b2c2d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8215",
    "data-name": "Rectangle 8215",
    width: 147,
    height: 45,
    rx: 5,
    transform: "translate(247 141)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8216",
    "data-name": "Rectangle 8216",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(256 194)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8217",
    "data-name": "Rectangle 8217",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(247 194)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8218",
    "data-name": "Rectangle 8218",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(256 206)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8219",
    "data-name": "Rectangle 8219",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(247 206)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8220",
    "data-name": "Rectangle 8220",
    width: 138,
    height: 6,
    rx: 2,
    transform: "translate(256 218)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8221",
    "data-name": "Rectangle 8221",
    width: 6,
    height: 6,
    rx: 3,
    transform: "translate(247 218)",
    fill: "#fff",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarktheme);
export default __webpack_public_path__ + "static/media/darktheme.819a4328cb8bc7ae23b19979a1b08992.svg";
export { ForwardRef as ReactComponent };